import { router } from '@inertiajs/vue3';

const TAB_PARAMETER = 'tab';
const SUB_TAB_PARAMETER = 'subTab';

/**
 * Handles the query parameters used by TabLayout to restore the selected tab.
 */
export const useTabs = () => {
    /**
     * @returns {{tab?: string, subTab?: string}}
     */
    function getCurrentTabParameters() {
        const parameters = new URLSearchParams(window.location.search);
        const tab = parameters.get(TAB_PARAMETER);
        const subTab = parameters.get(SUB_TAB_PARAMETER);

        return {
            ...(tab ? { [TAB_PARAMETER]: tab } : {}),
            ...(subTab ? { [SUB_TAB_PARAMETER]: subTab } : {}),
        };
    }

    /**
     * Visits the given url while keeping the currently selected tab and sub tab.
     *
     * @param {string} url
     * @param {Object} [options] - Inertia visit options.
     */
    function visitPreservingTabs(url, options = {}) {
        const target = new URL(url, window.location.origin);

        for (const [name, value] of Object.entries(getCurrentTabParameters())) {
            target.searchParams.set(name, value);
        }

        router.visit(target.toString(), options);
    }

    return {
        getCurrentTabParameters,
        visitPreservingTabs,
    };
};
